import * as ng from 'angular';
import * as uuid from 'uuid/v1';
import * as moment from 'moment';
import * as _ from 'underscore';

import { SiteConfig } from '../shared';
import { EventDetail } from '../events';

export class SyncService {
   static $inject = ['$http', 'config'];

   constructor(private $http:ng.IHttpService, private config:SiteConfig) {
      // TODO get appVersion from SharedAssemblyInfo.cs
      let appVersion = '1.0';
      this.deviceHeader = `${config.campaign.slug}/SelfReg,Self Registration Site/${appVersion}/4.1`;
   }

   readonly deviceHeader:string;

   setParticipant(participant:Participant) {
      localStorage.setItem('_participant', JSON.stringify(participant));
   }

   getParticipant():Participant {
      return JSON.parse(localStorage.getItem('_participant')) as Participant;
   }

   removeParticipant() {
      localStorage.removeItem('_participant');
   }

   newParticipant(event:EventDetail):Participant {
      let p = {
         wristbandID: uuid(),
         eventID: event.eventID,
         deviceName: this.config.campaign.slug, // choosen at random
         scanDate: moment().format()
      };

      if (selfRegExt.participantInit) {
         p = selfRegExt.participantInit(p);
      }

      return p;
   }

   submit(participant:Participant, token: string) {
      let url = `//${this.config.apiDomain}/api/selfReg/submit`;
      return this.$http.post(url, participant, {
         headers: {
            'X-Device': this.deviceHeader,
            'X-Token': this.config.token,
            'X-Challenge': token
         }
      });
   }

   submitMedia(wristbandId: string, eventId: number, fileName: string, data: string) {
      let url = `//${this.config.apiDomain}/api/selfReg/submitMedia`;

      let mediaBody:MediaFile = {
         wristbandID: wristbandId,
         data: data,
         eventID: eventId,
         fileName: fileName,
         metadata: []
      };

      return this.$http.post(url, mediaBody, {
         headers: {
            'X-Device': this.deviceHeader,
            'X-Token': this.config.token
         }
      });
   }
}

ng.module('selfReg')
   .service('syncService', SyncService);

export interface Participant {
   wristbandID:string;
   deviceName:string;
   eventID:number;
   eventUserID?:number;
   preRegID?:number;
   timeSlotID?:number;
   scanDate:string;

   title?:string;

   firstName?:string;
   middleName?:string;
   lastName?:string;

   locale?:string;

   sex?:string;

   address?:string;
   address2?:string;
   city?:string;
   state?:string;
   zip?:string;
   country?:string;

   dob?:string;

   company?:string;
   notes?:string;

   email?:string;
   phoneHome?:string;
   phoneWork?:string;
   phoneMobile?:string;

   contactOptin?:boolean;
   salesOptin?:boolean;
   promoOptin?:boolean;
   contestOptin?:boolean;

   guestTypeSlug?:string;

   surveyItems?:SurveyItem[];
}

export interface SurveyItem {
   name:string;
   value:string;
}

export interface MediaFile {
   wristbandID:string;
   eventID: number;
   data: string;
   fileName: string;
   metadata: any; // Record<string, string>;
}
